export const TYPE_REDUSER = {
  SELECT_COLOR_PARAMS: "SELECT_COLOR_PARAMS",
  SHOW_PARAMETER_GROUP: "SHOW_PARAMETER_GROUP",
  SET_SHARED_INFO: "SET_SHARED_INFO",
  CHANGE_MODAL_STATE: "CHANGE_MODAL_STATE",
  INIT_PLAYCANVAS_SETTINGS: "INIT_PLAYCANVAS_SETTINGS",
  INIT_SETTINGS_FROM_API: "INIT_SETTINGS_FROM_API",
  SET_ACTIVE_ITEM: "SET_ACTIVE_ITEM",
};

export const DEFAULT_BOAT_SKU = "intrigue-rf-250-dl";
export const FORM_STATUS = {
  NOT_SUBMITTED: "NOT_SUBMITTED",
  PROCESS: "PROCESS",
  SUBMITTED: "SUBMITTED",
};

export const ThreeKitApi = "https://preview.threekit.com/api";
export const ThreeKitToken = "6640574e-1ad0-441e-a97b-3b4b870a69e5";
export const orgId = "73fae6a8-b627-4cbd-a0b9-872cc83d386b";

export const restApi = `${
  window.location.origin.split(window.location.port)[0]
}3030`;

export const countryCode = [
  {
    code: "PY",
    name: "Paraguay",
  },
  {
    code: "QA",
    name: "Qatar",
  },
  {
    code: "RE",
    name: "Reunion Island",
  },
  {
    code: "RO",
    name: "Romania",
  },
  {
    code: "RS",
    name: "Serbia",
  },
  {
    code: "RU",
    name: "Russian Federation",
  },
  {
    code: "RW",
    name: "Rwanda",
  },
  {
    code: "SA",
    name: "Saudi Arabia",
  },
  {
    code: "SB",
    name: "Solomon Islands",
  },
  {
    code: "SC",
    name: "Seychelles",
  },
  {
    code: "SD",
    name: "Sudan",
  },
  {
    code: "SE",
    name: "Sweden",
  },
  {
    code: "SG",
    name: "Singapore",
  },
  {
    code: "SH",
    name: "St. Helena",
  },
  {
    code: "SI",
    name: "Slovenia",
  },
  {
    code: "SJ",
    name: "Svalbard and Jan Mayen Islands",
  },
  {
    code: "SK",
    name: "Slovakia",
  },
  {
    code: "SL",
    name: "Sierra Leone",
  },
  {
    code: "SM",
    name: "San Marino",
  },
  {
    code: "SN",
    name: "Senegal",
  },
  {
    code: "SO",
    name: "Somalia",
  },
  {
    code: "SR",
    name: "Suriname",
  },
  {
    code: "ST",
    name: "Sao Tome and Principe",
  },
  {
    code: "SV",
    name: "El Salvador",
  },
  {
    code: "SY",
    name: "Syrian Arab Republic",
  },
  {
    code: "SZ",
    name: "Swaziland",
  },
  {
    code: "TA",
    name: "Tristan da Cunha",
  },
  {
    code: "TC",
    name: "Turks and Caicos Islands",
  },
  {
    code: "TC",
    name: "Turks and Caicos Islands",
  },
  {
    code: "TD",
    name: "Chad",
  },
  {
    code: "TF",
    name: "French Southern Territories",
  },
  {
    code: "TG",
    name: "Togo",
  },
  {
    code: "TH",
    name: "Thailand",
  },
  {
    code: "TJ",
    name: "Tajikistan",
  },
  {
    code: "TK",
    name: "Tokelau",
  },
  {
    code: "TL",
    name: "East Timor",
  },
  {
    code: "TM",
    name: "Turkmenistan",
  },
  {
    code: "TN",
    name: "Tunisia",
  },
  {
    code: "TO",
    name: "Tonga",
  },
  {
    code: "TR",
    name: "Turkey",
  },
  {
    code: "TT",
    name: "Trinidad and Tobago",
  },
  {
    code: "TV",
    name: "Tuvalu",
  },
  {
    code: "TW",
    name: "Taiwan",
  },
  {
    code: "TZ",
    name: "Tanzania",
  },
  {
    code: "UA",
    name: "Ukraine",
  },
  {
    code: "UG",
    name: "Uganda",
  },
  {
    code: "UM",
    name: "US Minor Outlying Islands",
  },
  {
    code: "PS",
    name: "Palestinian Territories",
  },
  {
    code: "PT",
    name: "Portugal",
  },
  {
    code: "PW",
    name: "Palau",
  },
  {
    code: "MK",
    name: "Macedonia",
  },
  {
    code: "ML",
    name: "Mali",
  },
  {
    code: "MM",
    name: "Myanmar",
  },
  {
    code: "MN",
    name: "Mongolia",
  },
  {
    code: "MN",
    name: "Mongolia",
  },
  {
    code: "MO",
    name: "Macao",
  },
  {
    code: "MO",
    name: "Macao",
  },
  {
    code: "MP",
    name: "Northern Mariana Islands",
  },
  {
    code: "GA",
    name: "Gabon",
  },
  {
    code: "GD",
    name: "Grenada",
  },
  {
    code: "GE",
    name: "Georgia",
  },
  {
    code: "GF",
    name: "French Guiana",
  },
  {
    code: "GG",
    name: "Guernsey",
  },
  {
    code: "GH",
    name: "Ghana",
  },
  {
    code: "GI",
    name: "Gibraltar",
  },
  {
    code: "GL",
    name: "Greenland",
  },
  {
    code: "GM",
    name: "Gambia",
  },
  {
    code: "GN",
    name: "Guinea",
  },
  {
    code: "GP",
    name: "Guadeloupe",
  },
  {
    code: "GQ",
    name: "Equatorial Guinea",
  },
  {
    code: "GR",
    name: "Greece",
  },
  {
    code: "GS",
    name: "South Georgia and the South Sandwich Islands",
  },
  {
    code: "GT",
    name: "Guatemala",
  },
  {
    code: "GU",
    name: "Guam",
  },
  {
    code: "AC",
    name: "Ascension Island",
  },
  {
    code: "AD",
    name: "Andorra",
  },
  {
    code: "AE",
    name: "United Arab Emirates",
  },
  {
    code: "AW",
    name: "Aruba",
  },
  {
    code: "AZ",
    name: "Azerbaijan",
  },
  {
    code: "BA",
    name: "Bosnia-Herzegovina",
  },
  {
    code: "BB",
    name: "Barbados",
  },
  {
    code: "BD",
    name: "Bangladesh",
  },
  {
    code: "BF",
    name: "Burkina Faso",
  },
  {
    code: "BG",
    name: "Bulgaria",
  },
  {
    code: "BH",
    name: "Bahrain",
  },
  {
    code: "BI",
    name: "Burundi",
  },
  {
    code: "BJ",
    name: "Benin",
  },
  {
    code: "BM",
    name: "Bermuda",
  },
  {
    code: "BN",
    name: "Brunei Darussalam",
  },
  {
    code: "BO",
    name: "Bolivia",
  },
  {
    code: "BR",
    name: "Brazil",
  },
  {
    code: "MQ",
    name: "Martinique",
  },
  {
    code: "MR",
    name: "Mauritania",
  },
  {
    code: "MS",
    name: "Montserrat",
  },
  {
    code: "MT",
    name: "Malta",
  },
  {
    code: "MU",
    name: "Mauritius",
  },
  {
    code: "MV",
    name: "Maldives",
  },
  {
    code: "MW",
    name: "Malawi",
  },
  {
    code: "MY",
    name: "Malaysia",
  },
  {
    code: "MZ",
    name: "Mozambique",
  },
  {
    code: "NA",
    name: "Namibia",
  },
  {
    code: "NC",
    name: "New Caledonia",
  },
  {
    code: "NE",
    name: "Niger",
  },
  {
    code: "NF",
    name: "Norfolk Island",
  },
  {
    code: "NG",
    name: "Nigeria",
  },
  {
    code: "NI",
    name: "Nicaragua",
  },
  {
    code: "NL",
    name: "Netherlands",
  },
  {
    code: "NO",
    name: "Norway",
  },
  {
    code: "NP",
    name: "Nepal",
  },
  {
    code: "NR",
    name: "Nauru",
  },
  {
    code: "NU",
    name: "Niue",
  },
  {
    code: "NZ",
    name: "New Zealand",
  },
  {
    code: "OM",
    name: "Oman",
  },
  {
    code: "PA",
    name: "Panama",
  },
  {
    code: "PE",
    name: "Peru",
  },
  {
    code: "PF",
    name: "French Polynesia",
  },
  {
    code: "PG",
    name: "Papua New Guinea",
  },
  {
    code: "PH",
    name: "Philippines",
  },
  {
    code: "PK",
    name: "Pakistan",
  },
  {
    code: "PL",
    name: "Poland",
  },
  {
    code: "PM",
    name: "St. Pierre & Miquelon",
  },
  {
    code: "PN",
    name: "Pitcairn Island",
  },
  {
    code: "PR",
    name: "Puerto Rico",
  },
  {
    code: "AF",
    name: "Afghanistan",
  },
  {
    code: "AG",
    name: "Antigua and Barbuda",
  },
  {
    code: "AG",
    name: "Antigua and Barbuda",
  },
  {
    code: "AI",
    name: "Anguilla",
  },
  {
    code: "AL",
    name: "Albania",
  },
  {
    code: "AM",
    name: "Armenia",
  },
  {
    code: "AN",
    name: "Netherlands Antilles",
  },
  {
    code: "AO",
    name: "Angola",
  },
  {
    code: "AQ",
    name: "ANTARCTICA",
  },
  {
    code: "AS",
    name: "American Samoa",
  },
  {
    code: "DJ",
    name: "Djibouti",
  },
  {
    code: "DK",
    name: "Denmark",
  },
  {
    code: "DM",
    name: "Dominica",
  },
  {
    code: "DO",
    name: "Dominican Republic",
  },
  {
    code: "DZ",
    name: "Algeria",
  },
  {
    code: "EC",
    name: "Ecuador",
  },
  {
    code: "EE",
    name: "Estonia",
  },
  {
    code: "EG",
    name: "Egypt",
  },
  {
    code: "EH",
    name: "Western Sahara",
  },
  {
    code: "ER",
    name: "Eritrea",
  },
  {
    code: "ET",
    name: "Ethiopia",
  },
  {
    code: "FI",
    name: "Finland",
  },
  {
    code: "FJ",
    name: "Fiji",
  },
  {
    code: "FK",
    name: "Falkland Islands",
  },
  {
    code: "FM",
    name: "Micronesia, Federal State of",
  },
  {
    code: "BS",
    name: "Bahamas",
  },
  {
    code: "BT",
    name: "Bhutan",
  },
  {
    code: "BV",
    name: "BOUVET ISLAND",
  },
  {
    code: "BW",
    name: "Botswana",
  },
  {
    code: "BY",
    name: "Belarus",
  },
  {
    code: "BZ",
    name: "Belize",
  },
  {
    code: "CC",
    name: "Cocos (Keeling) Islands",
  },
  {
    code: "CD",
    name: "Congo, Democratic Republic of the",
  },
  {
    code: "CF",
    name: "Central African Republic",
  },
  {
    code: "CG",
    name: "Congo, Republic of",
  },
  { code: "CI", name: "Cote d'Ivoire" },
  {
    code: "CK",
    name: "Cook Islands",
  },
  {
    code: "CL",
    name: "Chile",
  },
  {
    code: "CM",
    name: "Cameroon",
  },
  {
    code: "CO",
    name: "Colombia",
  },
  {
    code: "CR",
    name: "Costa Rica",
  },
  {
    code: "CS",
    name: "Serbia & Montenegro",
  },
  {
    code: "CS",
    name: "Serbia & Montenegro",
  },
  {
    code: "CU",
    name: "Cuba",
  },
  {
    code: "CV",
    name: "Cape Verde",
  },
  {
    code: "CX",
    name: "Christmas Island",
  },
  {
    code: "CZ",
    name: "Czech Republic",
  },
  {
    code: "FO",
    name: "Faroe Islands",
  },
  {
    code: "GW",
    name: "Guinea-Bissau",
  },
  {
    code: "GY",
    name: "Guyana",
  },
  {
    code: "HK",
    name: "Hong Kong",
  },
  {
    code: "HM",
    name: "Heard and McDonald Islands",
  },
  {
    code: "HN",
    name: "Honduras",
  },
  {
    code: "HR",
    name: "Croatia",
  },
  {
    code: "HR",
    name: "Croatia",
  },
  {
    code: "HT",
    name: "Haiti",
  },
  {
    code: "HU",
    name: "Hungary",
  },
  {
    code: "ID",
    name: "Indonesia",
  },
  {
    code: "IE",
    name: "Ireland",
  },
  {
    code: "IL",
    name: "Israel",
  },
  {
    code: "IM",
    name: "Isle of Man",
  },
  {
    code: "IO",
    name: "BRITISH INDIAN OCEAN TERRITORY",
  },
  {
    code: "IQ",
    name: "Iraq",
  },
  {
    code: "IR",
    name: "Iran",
  },
  {
    code: "IS",
    name: "Iceland",
  },
  {
    code: "JE",
    name: "Jersey",
  },
  {
    code: "JM",
    name: "Jamaica",
  },
  {
    code: "JO",
    name: "Jordan",
  },
  {
    code: "JP",
    name: "Japan",
  },
  {
    code: "KE",
    name: "Kenya",
  },
  {
    code: "KG",
    name: "Kyrgyzstan",
  },
  {
    code: "KH",
    name: "Cambodia",
  },
  {
    code: "KI",
    name: "Kiribati",
  },
  {
    code: "KM",
    name: "Comoros",
  },
  {
    code: "KN",
    name: "Saint Kitts and Nevis",
  },
  {
    code: "KP",
    name: "North Korea",
  },
  {
    code: "KR",
    name: "South Korea",
  },
  {
    code: "KR",
    name: "South Korea",
  },
  {
    code: "KW",
    name: "Kuwait",
  },
  {
    code: "KY",
    name: "Cayman Islands",
  },
  {
    code: "KZ",
    name: "Kazakhstan",
  },
  {
    code: "LA",
    name: "Laos",
  },
  {
    code: "LB",
    name: "Lebanon",
  },
  {
    code: "LC",
    name: "Saint Lucia",
  },
  {
    code: "LI",
    name: "Liechtenstein",
  },
  {
    code: "LK",
    name: "Sri Lanka",
  },
  {
    code: "LR",
    name: "Liberia",
  },
  {
    code: "LS",
    name: "Lesotho",
  },
  {
    code: "LT",
    name: "Lithuania",
  },
  {
    code: "LU",
    name: "Luxembourg",
  },
  {
    code: "LV",
    name: "Latvia",
  },
  {
    code: "LY",
    name: "Libya",
  },
  {
    code: "MA",
    name: "Morocco",
  },
  {
    code: "MC",
    name: "Monaco",
  },
  {
    code: "MD",
    name: "Moldova, Republic of",
  },
  {
    code: "ME",
    name: "Montenegro",
  },
  {
    code: "MG",
    name: "Madagascar",
  },
  {
    code: "MH",
    name: "Marshall Islands",
  },
  {
    code: "VN",
    name: "Vietnam",
  },
  {
    code: "VU",
    name: "Vanuatu",
  },
  {
    code: "WF",
    name: "Wallis and Futuna Islands",
  },
  {
    code: "WL",
    name: "St. Lucia",
  },
  {
    code: "WS",
    name: "Western Samoa",
  },
  {
    code: "WV",
    name: "St. Vincent & The Grenadines",
  },
  {
    code: "YE",
    name: "Yemen",
  },
  {
    code: "YT",
    name: "Mayotte",
  },
  {
    code: "YU",
    name: "Yugoslavia",
  },
  {
    code: "ZA",
    name: "South Africa",
  },
  {
    code: "ZM",
    name: "Zambia",
  },
  {
    code: "ZW",
    name: "Zimbabwe",
  },
  {
    code: "UY",
    name: "Uruguay",
  },
  {
    code: "UZ",
    name: "Uzbekistan",
  },
  {
    code: "VA",
    name: "HOLY SEE (VATICAN CITY STATE)",
  },
  {
    code: "VC",
    name: "Saint Vincent and the Grenadines",
  },
  {
    code: "VE",
    name: "Venezuela",
  },
  {
    code: "VG",
    name: "Virgin Islands (British)",
  },
  {
    code: "VI",
    name: "Virgin Islands (USA)",
  },
  {
    code: "AT",
    name: "Austria",
  },
  {
    code: "AU",
    name: "Australia",
  },
  {
    code: "BE",
    name: "Belgium",
  },
  {
    code: "CA",
    name: "Canada",
  },
  {
    code: "CH",
    name: "Switzerland",
  },
  {
    code: "CN",
    name: "China",
  },
  {
    code: "CY",
    name: "Cyprus",
  },
  {
    code: "DE",
    name: "Germany",
  },
  {
    code: "IN",
    name: "India",
  },
  {
    code: "IT",
    name: "Italy",
  },
  {
    code: "MX",
    name: "Mexico",
  },
  {
    code: "ES",
    name: "Spain",
  },
  {
    code: "FR",
    name: "France",
  },
  {
    code: "GB",
    name: "United Kingdom",
  },
  {
    code: "AR",
    name: "Argentina",
  },
  {
    code: "US",
    name: "United States",
  },
];
